{
	"changelog": {
		"footer_link": "Contact us through support",
		"footer_note": "Looking for an older version or want to report an issue?",
		"hero": {
			"eyebrow": "Changelog",
			"subtitle": "What changed in SeaLedger, version by version. The most important new features, improvements, and fixes.",
			"title": "What’s new and updates",
			"updated": "Last updated · June 30, 2026"
		},
		"k": {
			"add": "New",
			"fix": "Fix",
			"imp": "Improved"
		},
		"tag": {
			"first_release": "First Release",
			"fix": "Bug Fixes",
			"major": "Major Release",
			"new": "Features"
		},
		"v1_0_0": {
			"date": "Mar 10, 2026",
			"item_1": "Card scanner, collection with per-set progress, and deck creation.",
			"item_2": "Database with over 3,000 cards and filter search."
		},
		"v1_1_0": {
			"date": "Apr 3, 2026",
			"item_1": "Wishlist: mark the cards you're looking for and find them in a snap.",
			"item_2": "Settings reorganized: Language, Notifications, Appearance, and About."
		},
		"v1_2_0": {
			"date": "Apr 28, 2026",
			"item_1": "Profile page redesigned as a personal hub with clickable stats.",
			"item_2": "Guest mode: use SeaLedger without an account, with data stored on device.",
			"item_3": "Faster card search with more relevant results."
		},
		"v1_2_1": {
			"date": "May 12, 2026",
			"item_1": "Fixed a rare freeze while scanning in low-light conditions.",
			"item_2": "Per-set completion percentages now update immediately after adding a card.",
			"item_3": "Faster sync at app startup."
		},
		"v1_3_0": {
			"date": "Jun 2, 2026",
			"item_1": "Deck builder with leader selection via picker (search, color, set, and grid).",
			"item_2": "Add cards to a deck with filters by type, color, cost, and set.",
			"item_3": "The wishlist now distinguishes wanted cards by language."
		},
		"v1_4_0": {
			"date": "Jun 30, 2026",
			"item_1": "Multilingual card tracking: track the same card in EN, JP, and FR with separate quantities and progress.",
			"item_2": "Language lens in the collection: filter to see only one language or all together.",
			"item_3": "\"Coming soon\" status for editions not yet released.",
			"item_4": "The scanner now automatically detects the card's print language."
		}
	},
	"collection_tracker": {
		"cta": {
			"title": "Track your collection"
		},
		"f1": {
			"body": "Completion percentages for every set, always up to date.",
			"title": "Per-set progress"
		},
		"f2": {
			"body": "Track the same card in EN, JP, and FR, each with its own quantity.",
			"title": "Multilingual inventory"
		},
		"f3": {
			"body": "Mark the cards you are hunting and keep them handy at the store.",
			"title": "Wishlist built in"
		},
		"hero": {
			"eyebrow": "Collection tracker",
			"lead": "Turn boxes and binders into a digital register. SeaLedger tracks every card by set and language, with completion percentages that update in real time.",
			"title": "Track your One Piece Card Game collection"
		}
	},
	"deck_builder": {
		"cta": {
			"title": "Build your first deck"
		},
		"f1": {
			"body": "Start from your leader and filter the cards that fit your strategy.",
			"title": "Leader-first building"
		},
		"f2": {
			"body": "Every card is marked by what is in your collection, across all languages.",
			"title": "Owned vs missing"
		},
		"f3": {
			"body": "Over 3,000 cards with filters by type, color, cost, and set.",
			"title": "Full card database"
		},
		"hero": {
			"eyebrow": "Deck builder",
			"lead": "Choose a leader and compose your deck from the full card database. SeaLedger shows what you already own and what you still need to complete it.",
			"title": "Build One Piece decks from your collection"
		}
	},
	"footer": {
		"changelog": "Changelog",
		"collection_tracker": "Collection tracker",
		"contact": "Contact support",
		"copyright": "© 2026 SeaLedger. All rights reserved.",
		"deck_builder": "Deck builder",
		"disclaimer": "SeaLedger is an independent app dedicated to One Piece Card Game collectors. It is not official and is not affiliated with, sponsored by, or endorsed by Bandai, Toei Animation, Eiichiro Oda, or the other holders of the game's trademarks and rights. \"One Piece\", the One Piece Card Game, and all card names, trademarks, and images belong to their respective owners.",
		"disclaimer_label": "Notice.",
		"faq": "FAQ",
		"features": "Features",
		"how": "How it works",
		"languages": "Languages",
		"legal": "Legal",
		"made_with": "Made with care for collectors · EN",
		"news": "What's new",
		"privacy": "Privacy Policy",
		"product": "Product",
		"scanner": "Scanner",
		"support": "Support",
		"tagline": "The digital ledger for your card collection. Scan, catalog, build.",
		"terms": "Terms of Service"
	},
	"landing": {
		"download": {
			"badge_apple_main": "App Store",
			"badge_apple_sub": "Download on",
			"badge_google_main": "Google Play",
			"badge_google_sub": "Get it on",
			"subtitle": "Free on iOS and Android. Your collection is waiting.",
			"title": "Start getting organized today"
		},
		"faq": {
			"a1": "Yes. You can scan, catalog, and build decks for free. SeaLedger Pro adds advanced features such as extended statistics and priority sync.",
			"a2": "Currently English (EN), Japanese (JP), and French (FR), each tracked independently. The app language can be set separately in settings.",
			"a3": "Yes, you can start as a guest and data stays on the device. Creating an account syncs your collection across devices and prevents data loss.",
			"a4": "Basic recognition works without a connection. Updating the database with new sets and syncing progress requires the network.",
			"a5": "No. SeaLedger is an independent project dedicated to One Piece Card Game collectors, not affiliated with or endorsed by Bandai or the other trademark holders. See the disclaimer at the bottom of the page.",
			"eyebrow": "FAQ",
			"q1": "Is SeaLedger free?",
			"q2": "Which card languages are supported?",
			"q3": "Can I use it without creating an account?",
			"q4": "Does the scanner work offline?",
			"q5": "Is SeaLedger an official app?",
			"title": "Frequently asked questions"
		},
		"features": {
			"collection_body": "Per-set progress, completion percentages, and the status of every card, always up to date.",
			"collection_title": "Living collection",
			"deck_body": "Compose decks with leaders and cards from the catalog, with hints on what you own and what you're missing.",
			"deck_title": "Deck builder",
			"eyebrow": "Features",
			"multilang_body": "Track the same card in EN, JP, and FR, each with its own quantity and progress.",
			"multilang_title": "True multilingual",
			"scanner_body": "Camera-based card recognition with automatic detection of set, number, and language.",
			"scanner_title": "Smart scanner",
			"search_body": "Filter by type, color, cost, and set to find any card in the database instantly.",
			"search_title": "Advanced search",
			"subtitle": "One app to track, search, wish for, and play.",
			"title": "Everything a collector needs",
			"wishlist_body": "Mark the cards you're looking for, in any language, and keep them handy when you're at the store.",
			"wishlist_title": "Wishlist"
		},
		"hero": {
			"badge_apple_main": "App Store",
			"badge_apple_sub": "Download on",
			"badge_google_main": "Google Play",
			"badge_google_sub": "Get it on",
			"eyebrow": "Dedicated to the One Piece Card Game",
			"lead": "The app built for One Piece Card Game collectors: scan a card with your camera, track it in every language, and build your decks. SeaLedger turns boxes and binders into a digital register that's always with you.",
			"phone_collection": "Collection",
			"stat_db_label": "cards in the database",
			"stat_db_value": "3,000+",
			"stat_langs": "EN · JP · FR",
			"stat_rating_label": "★ on the App Store",
			"stat_rating_value": "4.8",
			"title_em": "finally in order.",
			"title_lead": "Your collection,"
		},
		"how_it_works": {
			"eyebrow": "How it works",
			"step_1_body": "Frame the card: SeaLedger recognizes it, identifies set and number, and automatically detects the print language.",
			"step_1_title": "Scan",
			"step_2_body": "Add it to your collection with a tap. Quantity, owned language, and reading status update your progress in real time.",
			"step_2_title": "Catalog",
			"step_3_body": "Create your decks by choosing leaders and cards from the database. SeaLedger tells you what you already own and what's still missing.",
			"step_3_title": "Build",
			"subtitle": "No spreadsheets, no manual counting. Frame, confirm, done.",
			"title": "From box to register in three steps"
		},
		"languages": {
			"body": "Language is not a forced label: it's a lens. Filter your collection to see only English, Japanese, or French — or everything together. Each language has its own quantity, status, and percentage.",
			"eyebrow": "The SeaLedger difference",
			"lang_en": "English",
			"lang_fr": "French",
			"lang_jp": "Japanese",
			"lang_total": "Total",
			"list_1_label": "Ownership by language.",
			"list_1_text": "You know exactly which version you have and which one you're missing.",
			"list_2_label": "\"Coming soon\" status.",
			"list_2_text": "Editions not yet released have their own dedicated status.",
			"list_3_label": "Automatic detection.",
			"list_3_text": "The scanner figures out the print language on its own.",
			"tab_all": "All",
			"tab_en": "EN",
			"tab_fr": "FR",
			"tab_jp": "JP",
			"title": "One card, multiple languages. Every progress in its place."
		}
	},
	"mail_link": {
		"actions": {
			"download": "Get SeaLedger",
			"support": "Contact support"
		},
		"eyebrow": "Secure email link",
		"flows": {
			"change_email_new": {
				"destination": "In SeaLedger, open Settings → Account and security → Email, then restart the change if the app asks you to.",
				"subtitle": "This link confirms the new address for an email change. The confirmation belongs to your signed-in SeaLedger session.",
				"title": "Confirm your new email in SeaLedger"
			},
			"change_email_old": {
				"destination": "In SeaLedger, open Settings → Account and security → Email, then restart the change if the app asks you to.",
				"subtitle": "This link confirms the current address before an email change. The confirmation belongs to your signed-in SeaLedger session.",
				"title": "Confirm your current email in SeaLedger"
			},
			"invite": {
				"destination": "Once SeaLedger is installed, return to the invite and open it again to carry its referral into the app.",
				"subtitle": "A SeaLedger collector invited you. Open the invite on a device with the app installed to continue.",
				"title": "Your SeaLedger invite is ready"
			},
			"magic_link": {
				"destination": "SeaLedger will finish sign-in. If your account uses two-factor authentication, the app will ask for the next factor there.",
				"subtitle": "This one-time sign-in link is completed in SeaLedger so the new session stays protected on your device.",
				"title": "Continue sign-in in SeaLedger"
			},
			"reset_password": {
				"destination": "SeaLedger will open the password reset screen, where you can choose a new password and finish securely.",
				"subtitle": "This one-time link authorizes a password reset. Complete it in SeaLedger so your new session stays on your device.",
				"title": "Reset your password in SeaLedger"
			},
			"verify_email": {
				"destination": "SeaLedger will verify the address and either open your account or ask for the next security step.",
				"subtitle": "This one-time link verifies your email address. Complete it in SeaLedger to keep the verification tied to your account.",
				"title": "Verify your email in SeaLedger"
			}
		},
		"missing": {
			"body": "The address does not contain the proof sent by email. Request a fresh message from SeaLedger instead of editing this URL.",
			"title": "This link is incomplete"
		},
		"ready": {
			"body": "For your security, SeaLedger completes this action in the mobile app. This page never displays or stores the one-time proof.",
			"title": "The link reached SeaLedger"
		},
		"recovery": {
			"body": "If SeaLedger says the link expired or was already used, start the same action again in the app. We will send a fresh email with a new link.",
			"kicker": "Link expired or already used?",
			"security": "Do not forward the email or paste its link into a message: anyone holding an unused proof may be able to act on your account.",
			"title": "Start again without getting stuck"
		},
		"steps": {
			"install": "Install SeaLedger if needed, then open the app on this device.",
			"reopen": "Return to the original email and tap its link again. The installed app will take over.",
			"title": "Finish in three steps"
		}
	},
	"nav": {
		"download": "Download",
		"features": "Features",
		"how": "How it works",
		"language": "Language",
		"menu": "Menu",
		"news": "What's new",
		"support": "Support"
	},
	"privacy": {
		"callout": {
			"body_middle": " structured for demonstrative purposes and ",
			"body_prefix": "This text is a ",
			"body_suffix": ". Adapt it to your actual data processing practices and have it verified by a professional (e.g. GDPR compliance) before publishing.",
			"no_legal_advice": "does not constitute legal advice",
			"placeholder_word": "placeholder",
			"title": "Draft template."
		},
		"hero": {
			"eyebrow": "Legal",
			"subtitle": "What data we collect, why we use it, and your rights. Your collection is yours: we keep it safe, we don't sell it.",
			"title": "Privacy Policy",
			"updated": "Effective from · June 30, 2026"
		},
		"p1": {
			"body_prefix": "The data controller is the SeaLedger team. To exercise your rights or for privacy questions, you can contact us at ",
			"body_suffix": ".",
			"email": "privacy@sealedger.app",
			"title": "Data Controller"
		},
		"p10": {
			"body_middle": " or from the ",
			"body_prefix": "For any privacy questions, write to us at ",
			"body_suffix": ".",
			"email": "privacy@sealedger.app",
			"support_link": "Contact support",
			"title": "Contact"
		},
		"p2": {
			"guest_note": "If you use SeaLedger as a guest, collection data stays on your device until you create an account.",
			"item_account_desc": " username and email, if you create an account.",
			"item_account_label": "Account data:",
			"item_collection_desc": " cards, quantities, languages, wishlists, and decks you add.",
			"item_collection_label": "Collection data:",
			"item_technical_desc": " device type, app version, and aggregated diagnostic data.",
			"item_technical_label": "Technical data:",
			"item_usage_desc": " anonymous interactions useful for improving the product.",
			"item_usage_label": "Usage data:",
			"title": "Data we collect"
		},
		"p3": {
			"item_communications": "send you service communications (e.g. important notices).",
			"item_features": "improve stability, performance, and new features;",
			"item_progress": "keep your collection progress up to date;",
			"item_sync": "provide and synchronize the service across your devices;",
			"title": "Why we use your data"
		},
		"p4": {
			"body_prefix": "The scanner uses the camera only to recognize cards. The framed images are processed to identify the card and ",
			"body_suffix": " as a photo archive, unless you explicitly save them.",
			"not_stored": "are not stored",
			"title": "Camera and scanning"
		},
		"p5": {
			"body": "We retain account data for as long as the account is active. You can request deletion at any time; after the request, associated data is deleted within a reasonable timeframe, unless required by law.",
			"title": "Data retention"
		},
		"p6": {
			"body": "We do not sell your data. We may use providers (e.g. hosting, analytics) that process data on our behalf and according to our instructions. We may disclose data if required by law.",
			"title": "Sharing with third parties"
		},
		"p7": {
			"body_prefix": "Under applicable law, you have the right to access, rectify, erase, and port your data, as well as to object to or restrict its processing. To exercise these rights, write to us from the ",
			"body_suffix": ".",
			"support_link": "support",
			"title": "Your rights"
		},
		"p8": {
			"body": "SeaLedger is not intended for minors below the minimum age required by local law. We do not knowingly collect data from minors without the consent of those who hold parental responsibility.",
			"title": "Minors"
		},
		"p9": {
			"body": "We may update this policy. In case of significant changes, we will notify you in the app or by email, updating the \"effective from\" date at the top of the page.",
			"title": "Changes to this policy"
		},
		"see_also": {
			"body_prefix": "See also the ",
			"body_suffix": ".",
			"terms_link": "Terms of Service"
		},
		"toc": {
			"p1": "1. Controller",
			"p10": "10. Contact",
			"p2": "2. Data collected",
			"p3": "3. Purpose",
			"p4": "4. Camera",
			"p5": "5. Retention",
			"p6": "6. Sharing",
			"p7": "7. Your rights",
			"p8": "8. Minors",
			"p9": "9. Changes",
			"title": "Index"
		}
	},
	"scanner": {
		"cta": {
			"title": "Start scanning today"
		},
		"f1": {
			"body": "EN, JP, and FR are recognized on their own — no manual tagging.",
			"title": "Automatic language detection"
		},
		"f2": {
			"body": "Basic recognition runs without a connection; sync when you are back online.",
			"title": "Works offline"
		},
		"f3": {
			"body": "Every scan updates your per-set progress and owned quantities in real time.",
			"title": "Instant cataloging"
		},
		"hero": {
			"eyebrow": "Card scanner",
			"lead": "Point your camera at any One Piece Card Game card. SeaLedger recognizes the set, number, and print language automatically, and adds it to your collection with a single tap.",
			"title": "Scan your One Piece cards in seconds"
		}
	},
	"seo": {
		"changelog": {
			"description": "See what's new in SeaLedger: the latest features, improvements, and fixes for the One Piece Card Game collection app.",
			"title": "Changelog — SeaLedger updates"
		},
		"collection_tracker": {
			"description": "Track your One Piece Card Game collection by set and language. See completion percentages for EN, JP, and FR at a glance. Free on iOS and Android.",
			"title": "One Piece Card Game collection tracker — SeaLedger"
		},
		"deck_builder": {
			"description": "Build One Piece Card Game decks with leaders and cards from a 3,000+ card database. See what you own and what you are missing. Free on iOS and Android.",
			"title": "One Piece Card Game deck builder — SeaLedger"
		},
		"home": {
			"description": "Scan, catalog, and track your One Piece Card Game collection in every language. Build decks, manage your wishlist, and follow your set progress. Free on iOS and Android.",
			"title": "SeaLedger — One Piece Card Game collection tracker & scanner"
		},
		"privacy": {
			"description": "How SeaLedger handles and protects your data. Your collection is yours — we keep it safe and we don't sell it.",
			"title": "Privacy Policy — SeaLedger"
		},
		"scanner": {
			"description": "Scan One Piece Card Game cards with your camera. SeaLedger recognizes set, number, and language automatically — even offline. Free on iOS and Android.",
			"title": "One Piece Card Game scanner app — SeaLedger"
		},
		"support": {
			"description": "Get help with SeaLedger: card scanner, sync, accounts, and SeaLedger Pro. Find answers to common questions and contact us.",
			"title": "Support — SeaLedger"
		},
		"terms": {
			"description": "Read the SeaLedger Terms of Service for the One Piece Card Game collection app.",
			"title": "Terms of Service — SeaLedger"
		}
	},
	"support": {
		"contacts": {
			"email_label": "Email",
			"email_value": "supporto@sealedger.app",
			"heading": "Direct contacts",
			"hours_label": "Hours",
			"hours_value": "Mon–Fri · 9:00–18:00 (CET)",
			"response_label": "Response time",
			"response_value": "On average within 1 business day"
		},
		"faq": {
			"eyebrow": "FAQ",
			"heading": "Maybe you'll find the answer right away",
			"q1": {
				"answer": "Make sure you have good light and that the card is well framed. If it persists, add it manually via search and report it to us — we update the database frequently.",
				"question": "The scanner doesn't recognise a card — what should I do?"
			},
			"q2": {
				"answer": "If you were using guest mode, the data was only on the old device. With an account the collection syncs: sign in with the same credentials to get it back.",
				"question": "I lost my collection after changing phones."
			},
			"q3": {
				"answer": "Renewals and cancellations are managed from your App Store or Google Play settings, in the subscriptions section of your store account.",
				"question": "How do I manage my SeaLedger Pro subscription?"
			},
			"q4": {
				"answer": "Write to us via the form, choosing «Missing or incorrect card report», and indicate the set, number and language — we'll fix it as soon as possible.",
				"question": "A card in the database is wrong or missing."
			},
			"q5": {
				"answer_email": "privacy@sealedger.app",
				"answer_part1": "You can request it via the form or by writing to",
				"answer_part2": ". More details in the",
				"answer_policy_link": "Privacy Policy",
				"question": "I want to delete my account and data."
			}
		},
		"form": {
			"card_heading": "Submit a request",
			"card_sub": "The more details you give us, the faster we can help.",
			"categories": {
				"account": "Account and access",
				"card_report": "Missing or incorrect card report",
				"collection": "Collection or synchronisation",
				"other": "Other",
				"scanner": "Scanner problem",
				"subscription": "SeaLedger Pro subscription"
			},
			"errors": {
				"email_invalid": "Enter a valid email address",
				"message_required": "Message is required",
				"name_required": "Name is required",
				"subject_required": "Subject is required"
			},
			"fields": {
				"category_label": "Category",
				"email_label": "Email",
				"email_placeholder": "you@example.com",
				"message_label": "Message",
				"message_placeholder": "Describe what's happening, on which device and in which screen…",
				"name_label": "Name",
				"name_placeholder": "Your name",
				"subject_label": "Subject",
				"subject_placeholder": "Summarise in one line"
			},
			"note_device": "Include device model and app version (Settings → About) for faster help.",
			"privacy_link_text": "Privacy Policy",
			"privacy_note_prefix": "By submitting you accept our",
			"submit": "Submit request"
		},
		"hero": {
			"description": "Write to us via the form below, check the frequently asked questions, or use our direct contacts. We reply to everyone.",
			"eyebrow": "Support",
			"title": "How can we help you?"
		},
		"status": {
			"degraded": "Service unavailable",
			"degraded_description": "The backend is not responding correctly to the health check request.",
			"description": "Scanner, synchronisation and database are working normally.",
			"heading": "Service status",
			"ok": "All systems operational"
		},
		"toast": {
			"message": "Request submitted — we'll reply by email."
		}
	},
	"terms": {
		"callout": {
			"label": "Draft model.",
			"mid_emphasis": " structured for demonstration purposes and ",
			"no_legal": "does not constitute legal advice",
			"placeholder_word": "placeholder",
			"post_emphasis": ". Before publishing, have it reviewed and adapted by a legal professional according to your jurisdiction.",
			"pre_placeholder": " This text is a "
		},
		"footer_note": {
			"post": ".",
			"pre": "See also the ",
			"privacy_link": "Privacy Policy"
		},
		"hero": {
			"effective": "Effective from · August 7, 2026",
			"eyebrow": "Legal",
			"subtitle": "The rules for using SeaLedger. By using the app you accept the terms described on this page.",
			"title": "Terms of Service"
		},
		"s1": {
			"body": "By downloading, installing or using SeaLedger (\"the app\", \"the service\") you fully accept these Terms of Service. If you do not accept them, we ask that you do not use the app.",
			"title": "Acceptance of Terms"
		},
		"s10": {
			"body": "To the extent permitted by law, SeaLedger is not liable for indirect, incidental, or consequential damages arising from the use or inability to use the service, including any potential loss of data.",
			"title": "Limitation of Liability"
		},
		"s11": {
			"body": "We may update these terms. In the event of material changes, we will notify you in the app or via email. Continued use after the update constitutes acceptance of the new terms.",
			"title": "Changes to Terms"
		},
		"s12": {
			"body_mid": " page or at the address ",
			"body_post": ".",
			"body_pre": "These terms are governed by applicable law to be specified based on your jurisdiction. For any questions, write to us from the ",
			"support_link": "Contact support",
			"title": "Applicable Law and Contacts"
		},
		"s2": {
			"body": "SeaLedger is an application that allows collectors to catalog One Piece Card Game cards, track ownership in multiple languages, manage a wishlist, and build decks. The service is provided \"as is\" and may evolve over time.",
			"title": "Service Description"
		},
		"s3": {
			"body": "You can use SeaLedger as a guest or create an account to sync your data. You are responsible for keeping your credentials confidential and for all activity carried out through your account.",
			"item1": "You must provide accurate information when registering.",
			"item2": "You must meet the minimum age required by the law of your jurisdiction.",
			"item3": "You must notify us promptly in the event of unauthorized use of your account.",
			"title": "User Account"
		},
		"s4": {
			"body": "You agree to use SeaLedger in compliance with the law and not to:",
			"item1": "attempt to access without authorization the systems or data of other users;",
			"item2": "interfere with the operation of the service or circumvent its security measures;",
			"item3": "use the app for unlawful, fraudulent, or rights-infringing purposes.",
			"title": "Permitted Use"
		},
		"s5": {
			"body": "The data you enter (collection, decks, notes) remains yours. By granting us a limited license, you authorize us to process it solely for the purpose of providing the service, for example for syncing between devices.",
			"title": "User Content"
		},
		"s6": {
			"body": "SeaLedger is an independent project. It is not affiliated with, sponsored by, or endorsed by the holders of card trademarks and rights. Card names, images, and trademarks belong to their respective owners and are used for identification and cataloging purposes only.",
			"title": "Third-Party Trademarks and Rights"
		},
		"s7": {
			"body": "Some advanced features may require SeaLedger Pro, a paid subscription managed through the App Store or Google Play. Renewals, pricing, and cancellations are also subject to the terms of the respective store.",
			"title": "Subscriptions and Purchases"
		},
		"s8": {
			"body": "The service is provided \"as is\" and \"as available\". While we strive for database accuracy, we do not guarantee it is error-free, complete, or always available.",
			"title": "Disclaimer of Warranties"
		},
		"s9": {
			"body": "SeaLedger displays market data and estimated values to help you organize your collection. This information is indicative only.",
			"item1": "Data comes from third-party sources and may be delayed, incomplete, inaccurate, or temporarily unavailable.",
			"item2": "Very low-value cards are supported but may be updated less frequently; rounding and small market movements can materially affect the displayed figure.",
			"item3": "A card or collection estimate depends on the available price, source, condition, currency, and last update; unpriced cards may not contribute to the total.",
			"item4": "No price or estimated value is a guaranteed sale or purchase price, professional appraisal, financial advice, offer, or commitment by SeaLedger or any third-party source.",
			"title": "Market Prices and Estimated Values"
		},
		"toc": {
			"heading": "Contents",
			"s1": "1. Acceptance",
			"s10": "10. Liability",
			"s11": "11. Changes",
			"s12": "12. Law & Contacts",
			"s2": "2. The Service",
			"s3": "3. Account",
			"s4": "4. Permitted Use",
			"s5": "5. Content",
			"s6": "6. Third-Party Marks",
			"s7": "7. Subscriptions",
			"s8": "8. Warranties",
			"s9": "9. Prices & Estimates"
		}
	}
}
